import { combineReducers } from "redux";

import returnReasonList from "./returnReasonList";
import fetching from "./fetching";

export default combineReducers({ returnReasonList, fetching });
